import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router';

import { RootState } from '@/redux/store';

export const PublicRoute = () => {
  const { isUserAuthenticated } = useSelector((state: RootState) => state.auth);

  return isUserAuthenticated ? <Navigate to="/" /> : <Outlet />;
};
